import { guideSteps } from '@/mocks/anime';

const qualityNotes = [
  {
    icon: 'ri-tv-2-line',
    title: '高清播放怎么理解',
    desc: '默认以高清画质呈现画面，网络条件一般时可在播放页手动切换到更流畅的档位，清晰度与流畅度之间由你自己取舍。',
  },
  {
    icon: 'ri-shield-star-line',
    title: '无广告的观看体验',
    desc: '观看过程不插入弹窗与中断式广告，让剧情保持连贯；页面中出现的提示与说明都服务于内容本身，不打断观看。',
  },
  {
    icon: 'ri-stack-line',
    title: '全集与连载的区别',
    desc: '已完结作品按全集整理，适合一次性补完；连载作品显示当前进度，配合更新时间表可以按节奏追更。',
  },
];

export default function GuideSection() {
  return (
    <section id="guide" className="bg-background-100 py-14 md:py-20 border-y border-background-200">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-start">
          <div>
            <span className="text-xs font-medium tracking-wide text-primary-600">观看指南</span>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl font-semibold text-foreground-950">
              从找到作品到安心看完，只差这几步
            </h2>
            <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-700">
              不少人打开一个动漫页面后反而不知道从哪开始。这里把常用流程拆成四步，按顺序走一遍，就能把「想看的」和「能看的」对齐。
            </p>

            <ol className="mt-7 space-y-4">
              {guideSteps.map((step) => (
                <li key={step.step} className="flex gap-4">
                  <span className="w-11 h-11 shrink-0 flex items-center justify-center rounded-lg bg-background-50 border border-background-200 font-heading font-semibold text-primary-600">
                    {step.step}
                  </span>
                  <div className="pt-0.5">
                    <h3 className="text-sm font-semibold text-foreground-950">{step.title}</h3>
                    <p className="mt-1 text-sm leading-relaxed text-foreground-600">{step.desc}</p>
                  </div>
                </li>
              ))}
            </ol>

            <div className="mt-7 rounded-lg bg-accent-50 border border-accent-200 p-4 flex items-start gap-3">
              <span className="w-9 h-9 shrink-0 flex items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className="ri-lightbulb-line text-lg"></i>
              </span>
              <p className="text-sm leading-relaxed text-foreground-700">
                <strong className="font-semibold text-foreground-950">小提示：</strong>
                拿不准看什么时，可以先选一个题材标签，再按评分排序浏览简介，通常两三部之内就能锁定目标。
              </p>
            </div>
          </div>

          <div>
            <div className="rounded-lg overflow-hidden border border-background-200 aspect-[16/10]">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20a%20cozy%20living%20room%20at%20evening%20with%20a%20large%20screen%20glowing%20warmly%2C%20shelves%20of%20media%20and%20a%20cup%20of%20tea%2C%20soft%20sakura%20pink%20and%20amber%20palette%2C%20calm%20cinematic%20mood%2C%20no%20text&width=1200&height=750&seq=anime-guide-visual&orientation=landscape"
                alt=""
                className="w-full h-full object-cover object-top"
              />
            </div>

            <div className="mt-5 space-y-3">
              {qualityNotes.map((note) => (
                <div
                  key={note.title}
                  className="flex items-start gap-3 rounded-lg bg-background-50 border border-background-200 p-4"
                >
                  <span className="w-9 h-9 shrink-0 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                    <i className={`${note.icon} text-lg`}></i>
                  </span>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-900">{note.title}</h3>
                    <p className="mt-1 text-xs leading-relaxed text-foreground-600">{note.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}